
import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'

import PrimarySection from './Section/Primary'
import SettingSection from './Section/Setting'
import SchedulesSection from './Section/Schedules'
import DriverBlacklistSection from './Section/DriverBlacklist'
import OrderLimitationSection from '@abra/panels/OrderLimitation'
import ShowActiveJobsPopup from '@abra/elements/Popup/ShowActiveJobs'

const CompanyService = ({ companyContractLabel, companycontract_id, company, ...props }) =>
  <>
    <ShowActiveJobsPopup />
    <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
      <Grid container rowSpacing={1}>
        <Grid size={12}>
          <FormHeader
            subTitle={I18n.t('link.companyservice')}
            onLinkClick={() => window.open(`/company/${company}/contract/${companycontract_id}`, '_blank')}
            linkText={companyContractLabel}
            closeOnBack={!!companycontract_id}
          />
        </Grid>
        <Grid size={12}>
          <GridStepper groupsCount={[5]} activeStep={0} orientation="vertical">
            <Step><PrimarySection /></Step>
            <Step><SettingSection /></Step>
            <Step><DriverBlacklistSection /></Step>
            <Step><SchedulesSection /></Step>
            <Step><OrderLimitationSection model='companyorderlimit' company={company} /></Step>
          </GridStepper>
        </Grid>
      </Grid>
    </Box>
  </>

export default React.memo(CompanyService)
